module.exports = __webpack_public_path__ + "img/playstore.091779b4.jpg";